export const checkIfDateIsValidBR = (dateString = '01/01/2000') => {
  const datePtBr = dateString
    .replace(/[^\d]/g, '')
    .replace(/(\d{2})(\d{2})(\d{4})/, '$2/$1/$3')
  return new Date(datePtBr).toDateString() !== 'Invalid Date' ? true : false
}
